module.exports = __webpack_public_path__ + "img/dynamic-1.400b0130.png";